import axios from 'axios';

import {
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAIL,
} from '../../reduser/Notification/getNotications';

export const allNotification = (options = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_NOTIFICATION_REQUEST.toString() });
    const page = options?.page || 1;
    const limit = options?.limit || 100;
    const receiverId = options?.receiverId ? `&receiverId=${encodeURIComponent(options.receiverId)}` : '';
    const link = `v2/notifications?page=${page}&pageSize=${limit}${receiverId}`;
    const { data } = await axios.get(link, { withCredentials: true });
    const normalizedNotifications = Array.isArray(data?.data?.items)
      ? data.data.items.map((n) => ({
          ...n,
          read: Boolean(n?.readAt || String(n?.status || '').toUpperCase() === 'READ'),
        }))
      : [];

    dispatch({
      type: GET_NOTIFICATION_SUCCESS.toString(),
      payload: normalizedNotifications,
    });
  } catch (error) {
    dispatch({
      type: GET_NOTIFICATION_FAIL.toString(),
      payload: error?.response?.data?.message,
    });
  }
};
